<template>
  <div>
    <!-- 구매자정보 BasicInformationSection -->
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header">
            <h3>구매자정보</h3>
          </div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                <label for="selling-store-name">구매대리점</label>
              </dt>
              <dd class="field-control">
                <input
                  id="selling-store-name"
                  v-model="openMarketInfo.agentName"
                  type="text"
                  name="agentName"
                  class="input-text-disabled input-font"
                  readonly
                  title="구매대리점 명"
                />
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="selling-mall-name">구매쇼핑몰</label>
              </dt>
              <dd class="field-control">
                <input
                  id="selling-mall-name"
                  v-model="openMarketInfo.openMarketName"
                  type="text"
                  name="openMarketName"
                  class="input-text-disabled input-font"
                  readonly
                  title="구매쇼핑몰 명"
                />
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <!-- 가입자 CustomerSection -->
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>가입자</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                <label for="customer-type">고객구분</label>
              </dt>
              <dd class="field-control">
                <input
                  id="customer-type"
                  v-model="custKdNm"
                  type="text"
                  name="customerType"
                  class="input-text input-font input-text-disabled"
                  readonly
                  title="가입자이름"
                />
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="registration-customer-name">가입자명</label>
              </dt>
              <dd class="field-control">
                <input
                  id="registration-customer-name"
                  v-model="$store.state.step1.customer.name"
                  type="text"
                  name="name"
                  class="input-text-disabled input-font"
                  readonly
                  title="가입자이름"
                />
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="registration-customer-telnumber"
                  >연락가능 전화번호</label
                >
              </dt>
              <dd class="field-control">
                <input
                  id="registration-customer-telnumber"
                  v-model="registration.aplcTlno"
                  ref="ref_aplcTlno"
                  type="text"
                  maxlength="11"
                  @input="onlyNumber"
                  name="available-phone-number"
                  autocomplete="off"
                  class="input-text input-font"
                  placeholder="'-' 없이 숫자만 입력"
                  title="가입자의 연락처 숫자만 입력"
                />
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="registration-customer-id-number1"
                  >주민등록번호</label
                >
              </dt>
              <dd class="field-control m-input-half">
                <input
                  id="registration-customer-id-number1"
                  v-model="$store.state.step1.customer.ssn1"
                  type="text"
                  name="ssn1"
                  maxlength="6"
                  @input="onlyNumber"
                  class="input-text-disabled input-font input-width-xsmall"
                  readonly
                  title="가입자 주민등록번호 앞 여섯자리"
                />
                <span class="field-group-space">-</span>
                <input
                  id="registration-customer-id-number2"
                  v-model="$store.state.step1.customer.ssn2"
                  type="password"
                  name="ssn2"
                  maxlength="7"
                  @input="onlyNumber"
                  class="input-text-disabled input-font input-width-xsmall"
                  readonly
                  title="가입자 주민등록번호 뒤 일곱자리"
                />
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="customer-validation-method"
                  >신분증 진위확인정보</label
                >
              </dt>
              <dd class="field-control">
                <div
                  class="field-control-sub"
                  v-if="$store.state.step1.customer.custKdCd !== 'A'"
                >
                  <select
                    id="customer-validation-method"
                    v-model="entrRsvTruthInfo.onetIdcdDivsCd"
                    ref="ref_onetIdcdDivsCd"
                    name="customer-validation-method"
                    class="input-width-small"
                  >
                    <option value="">선택</option>
                    <option
                      v-for="(validationMethod, index) in validationMethodList"
                      :key="index"
                      :value="validationMethod.cmmCdv"
                      >{{ validationMethod.cmmCdvNm }}</option
                    >
                  </select>
                </div>
                <div
                  class="field-control-sub"
                  v-if="$store.state.step1.customer.custKdCd === 'A'"
                >
                  <select
                    id="customer-validation-method"
                    name="customer-validation-method"
                    class="input-width-small"
                  >
                    <option value="">주민등록번호/성명</option>
                  </select>
                </div>
                <div
                  v-if="
                    entrRsvTruthInfo.onetIdcdDivsCd === 'REGID' ||
                      entrRsvTruthInfo.onetIdcdDivsCd === 'HANDI' ||
                      entrRsvTruthInfo.onetIdcdDivsCd === 'FORGN'
                  "
                  class="field-control-sub"
                >
                  <label
                    for="customer-checkway-idcard-date"
                    class="input-sub-text"
                    >발급일자</label
                  >
                  <input
                    id="customer-checkway-idcard-date"
                    v-model="entrRsvTruthInfo.isuDt"
                    type="text"
                    name="issued-date"
                    @input="onlyNumber"
                    ref="ref_regisHandiIsuDt"
                    class="input-text input-font"
                    maxlength="8"
                    placeholder="예) 20110809"
                    title="주민등록증 발급일자 여덟자리 입력"
                  />
                </div>
                <div
                  v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE'"
                  class="field-control-sub"
                >
                  <div class="field-control-sub">
                    <select
                      v-model="entrRsvTruthInfo.drvLcnsIsuAreaCd"
                      name="regions"
                      title="운전면허 지역선택"
                    >
                      <option value="">선택</option>
                      <option
                        v-for="(driverRegion, index) in driverRegionList"
                        :key="index"
                        :value="driverRegion.cmmCdv"
                        >{{ driverRegion.cmmCdvNm }}</option
                      >
                    </select>
                    <label
                      for="customer-checkway-drivinglicense-no"
                      class="input-sub-text"
                      >운전면허번호</label
                    >
                    <input
                      id="customer-checkway-drivinglicense-no"
                      placeholder='"-" 제외한 10자리 숫자 입력'
                      v-model="entrRsvTruthInfo.drvLcnsNo"
                      ref="ref_drvLcnsNo"
                      @input="onlyNumber"
                      maxlength="10"
                      type="text"
                      name="license-number"
                      class="input-text input-font"
                      title="운전면허번호 열 자리 입력"
                    />
                  </div>
                  <div class="field-control-sub">
                    <label
                      for="customer-checkway-drivinglicense-date"
                      class="input-sub-text"
                      >발급일자</label
                    >
                    <input
                      id="customer-checkway-drivinglicense-date"
                      v-model="entrRsvTruthInfo.isuDt"
                      maxlength="8"
                      @input="onlyNumber"
                      ref="ref_driveIsuDt"
                      type="text"
                      name="issued-date"
                      class="input-text input-font"
                      placeholder="예) 20110809"
                      title="운전면허 발급일자 여덟자리 입력"
                    />
                  </div>
                </div>
                <div
                  v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'MERIT'"
                  class="field-control-sub"
                >
                  <div class="field-control-sub">
                    <label
                      for="customer-checkway-merit-no"
                      class="input-sub-text"
                      >보훈번호
                    </label>
                    <input
                      id="customer-checkway-merit-no"
                      v-model="entrRsvTruthInfo.monmCsntNo"
                      type="text"
                      maxlength="10"
                      @input="onlyNumber"
                      name="monm-csnt-no"
                      ref="ref_monmCsntNo"
                      class="input-text input-font"
                      placeholder="'-'없이 입력하세요"
                      title="보훈번호 열 자리 숫자 입력"
                    />
                    <label
                      for="customer-checkway-merit-date"
                      class="input-sub-text"
                      >발급일자</label
                    >
                    <input
                      id="customer-checkway-merit-date"
                      v-model="entrRsvTruthInfo.isuDt"
                      type="text"
                      @input="onlyNumber"
                      maxlength="8"
                      ref="ref_meritIsuDt"
                      name="issued-date"
                      class="input-text input-font"
                      placeholder="예) 20110809"
                      title="보훈번호 발급일자 여덟자리 입력"
                    />
                  </div>
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label>고객주소</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div
                    id="radio-button-container-address-type-home"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="customer-address-select-home"
                      ref="ref_billDivsCd"
                      v-model="registration.billDivsCd"
                      type="radio"
                      name="address-type"
                      value="H"
                      class="input-radio"
                      title="가입자 주소 선택"
                    />
                    <label
                      for="customer-address-select-home"
                      class="input-label"
                      >자택</label
                    >
                  </div>
                  <div
                    id="radio-button-container-address-type-office"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="customer-address-select-office"
                      v-model="registration.billDivsCd"
                      type="radio"
                      name="address-type"
                      value="O"
                      class="input-radio"
                      title="가입자 주소 선택"
                    />
                    <label
                      for="customer-address-select-office"
                      class="input-label"
                      >직장</label
                    >
                  </div>
                  <div
                    id="radio-button-container-address-type-theOthers"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="customer-address-select-others"
                      v-model="registration.billDivsCd"
                      type="radio"
                      name="address-type"
                      value="E"
                      class="input-radio"
                      title="가입자 주소 선택"
                    />
                    <label
                      for="customer-address-select-others"
                      class="input-label"
                      >기타</label
                    >
                  </div>
                </div>
                <div class="field-control-sub m-input-half">
                  <input
                    v-model="registration.crplZpcd"
                    type="text"
                    name="postCode"
                    class="input-text input-width-xsmall input-font input-text-disabled"
                    placeholder="우편번호"
                    readonly
                    title="우편번호"
                  />
                  <span class="field-group-space"></span>
                  <button
                    @click="zipcodeAddressPop('customer')"
                    title="새창열림"
                    type="button"
                    ref="search"
                    name="search"
                  >
                    주소찾기
                  </button>
                </div>

                <div class="field-control-sub">
                  <input
                    v-model="registration.crplAddr"
                    type="text"
                    name="address1"
                    class="input-text input-width-xlarge input-font input-text-disabled"
                    readonly
                    tite="가입자 기본주소"
                  />
                </div>
                <div class="field-control-sub">
                  <input
                    v-model="registration.crplDadr"
                    type="text"
                    name="address2"
                    class="input-text input-width-xlarge input-font input-text-disabled"
                    readonly
                    title="가입자 상세주소"
                  />
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label>청구서 수령방법</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div
                    id="radio-button-container-bill-type-email"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="bill-type-email-select"
                      ref="ref_bltxRcepMthdCd"
                      v-model="registration.bltxRcepMthdCd"
                      type="radio"
                      name="bill-type"
                      value="2"
                      class="input-radio"
                      title="청구서 수령방법 선택"
                    />
                    <label for="bill-type-email-select" class="input-label"
                      >E-MAIL(청구서 내용 상세)</label
                    >
                  </div>
                  <!-- 휴대폰(청구서 내용 간편) 에서  App 청구서 로 변경 (2025.11.27) -->
                  <div
                    id="radio-button-container-bill-type-mobile"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="bill-type-mobile-select"
                      v-model="registration.bltxRcepMthdCd"
                      type="radio"
                      name="bill-type"
                      value="5"
                      class="input-radio"
                      title="청구서 수령방법 선택"
                    />
                    <label for="bill-type-mobile-select" class="input-label"
                      >App 청구서</label
                    >
                  </div>
                  <!-- [ST][CSR ID:RITM2464842] 청구서유형 추가 (2025.11.27) -->
                  <div
                    id="radio-button-container-bill-type-app"
                    class="input-container input-horizontal"
                  >
                    <input
                      id="bill-type-app-select"
                      v-model="registration.bltxRcepMthdCd"
                      type="radio"
                      name="bill-type"
                      value="13"
                      class="input-radio"
                      title="청구서 수령방법 선택"
                    />
                    <label for="bill-type-app-select" class="input-label"
                      >E-MAIL + App 청구서</label
                    >
                  </div>                  
                  <!-- [ED][CSR ID:RITM2464842] 청구서유형 추가   -->
                </div>
                <!--- <div v-if="step1.customer.chargeSendType==='2'" class='field-control-sub'>   -->
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label>E-Mail</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div>
                    <span class="m-input-half">
                      <input
                        v-model="$store.state.step1.customer.emailId"
                        type="text"
                        @input="onlyText"
                        ref="ref_emailId"
                        name="emailId"
                        placeholder="email ID 입력"
                        class="input-text input-width-small input-font"
                        title="이메일 아이디 입력"
                      />
                      <span class="field-group-space">@</span>
                      <select
                        v-model="selectedEmailDomain"
                        name="emailDomainSelect"
                        class="input-width-xsmall"
                        title="이메일 도메인 선택"
                        @change="chgEmailDomain()"
                      >
                        <option value="">직접입력</option>
                        <option
                          v-for="emailDomain in emailDomainList"
                          v-bind:key="emailDomain.cmmCdv"
                          :value="emailDomain.cmmCdv"
                        >
                          {{ emailDomain.cmmCdvNm }}
                        </option>
                      </select>
                    </span>
                    <span class="m-input-half">
                      <input
                        v-model="$store.state.step1.customer.emailDomain"
                        ref="ref_emailDomain"
                        type="text"
                        @input="onlyText"
                        name="emailDomain"
                        class="input-text input-width-small input-font"
                        title="이메일 도메인 직접입력"
                      />
                      <button
                        type="submit"
                        ref="ref_subitEmail"
                        @click="subitEmail"
                      >
                        확인
                      </button>
                    </span>
                  </div>
                </div>
                <ul class="notice-text-list">
                  <li class="notice-text">
                    고객님께서 작성하신 신청내용을 받으실 수 있는 이메일을
                    기입하여 주세요.
                  </li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <!-- 법정대리인 CustomerSection -->
    <div
      class="registration-page"
      v-if="$store.state.step1.customer.custKdCd === 'A'"
    >
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>법정대리인(보호자)</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                <label for="registration-guardian-name">보호자명</label>
              </dt>
              <dd class="field-control">
                <input
                  id="registration-guardian-name"
                  ref="ref_lawcAgntNm"
                  v-model="registration.lawcAgntNm"
                  type="text"
                  @input="onlyText"
                  name="lawcAgntNm"
                  class="input-text input-font"
                  autocomplete="off"
                  title="법정대리인 성명 입력"
                />
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="registration-guardian-id-number1"
                  >주민등록번호</label
                >
              </dt>
              <dd class="field-control  m-input-three">
                <input
                  id="registration-guardian-id-number1"
                  ref="ref_lawcAgntSsn1"
                  v-model="lawcAgntSsn1"
                  type="text"
                  name="lawcSsn1"
                  maxlength="6"
                  class="input-font input-text input-width-xsmall"
                  autocomplete="off"
                  @input="onlyNumber"
                  title="법정대리인 주민등록번호 앞 여섯자리 입력"
                />
                <span class="field-group-space">-</span>
                <input
                  id="registration-guardian-id-number2"
                  ref="ref_lawcAgntSsn2"
                  v-model="lawcAgntSsn2"
                  type="password"
                  name="lawcSsn2"
                  maxlength="7"
                  class="input-font input-text input-width-xsmall"
                  autocomplete="new-password"
                  @input="onlyNumber"
                  title="법정대리인 주민등록번호 뒤 일곱자리 입력"
                />
                <span class="field-group-space"></span>
                <button @click="checkGuardian">실명확인</button>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="guardian-validation-method"
                  >신분증 진위확인정보</label
                >
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <select
                    id="guardian-validation-method"
                    ref="ref_lawConetIdcdDivsCd"
                    v-model="lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd"
                    name="customer-validation-method"
                    class="input-width-small"
                  >
                    <option value="">선택</option>
                    <option
                      v-for="(validationMethod, index) in validationMethodList"
                      :key="index"
                      :value="validationMethod.cmmCdv"
                      >{{ validationMethod.cmmCdvNm }}</option
                    >
                  </select>
                </div>
                <div
                  v-if="
                    lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'REGID' ||
                      lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'HANDI' ||
                      lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'FORGN'
                  "
                  class="field-control-sub"
                >
                  <label
                    for="customer-checkway-idcard-date"
                    class="input-sub-text"
                    >발급일자</label
                  >
                  <input
                    id="customer-checkway-idcard-date"
                    v-model="lawcAgntEntrRsvTruthInfo.isuDt"
                    type="text"
                    name="lawc-issued-date"
                    @input="onlyNumber"
                    ref="ref_lawcRegisHandiIsuDt"
                    class="input-text input-font"
                    maxlength="8"
                    placeholder="예) 20110809"
                    title="법정대리인 주민등록증 발급일자 여덟자리 입력"
                  />
                </div>
                <div
                  v-if="lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE'"
                  class="field-control-sub"
                >
                  <div class="field-control-sub">
                    <select
                      v-model="lawcAgntEntrRsvTruthInfo.drvLcnsIsuAreaCd"
                      name="regions"
                      title="운전면허 지역선택"
                    >
                      <option value="">선택</option>
                      <option
                        v-for="(driverRegion, index) in driverRegionList"
                        :key="index"
                        :value="driverRegion.cmmCdv"
                        >{{ driverRegion.cmmCdvNm }}</option
                      >
                    </select>
                    <label
                      for="customer-checkway-drivinglicense-no"
                      class="input-sub-text"
                      >운전면허번호</label
                    >
                    <input
                      id="customer-checkway-drivinglicense-no"
                      placeholder='"-" 제외한 10자리 숫자 입력'
                      v-model="lawcAgntEntrRsvTruthInfo.drvLcnsNo"
                      @input="onlyNumber"
                      maxlength="10"
                      ref="ref_lawcDrvLcnsNo"
                      type="text"
                      name="lawc-license-number"
                      class="input-text input-font"
                      title="법정대리인 운전면허번호 열 자리 입력"
                    />
                  </div>
                  <div class="field-control-sub">
                    <label
                      for="customer-checkway-drivinglicense-date"
                      class="input-sub-text"
                      >발급일자</label
                    >
                    <input
                      id="customer-checkway-drivinglicense-date"
                      v-model="lawcAgntEntrRsvTruthInfo.isuDt"
                      maxlength="8"
                      @input="onlyNumber"
                      type="text"
                      ref="ref_lawcDriveIsuDt"
                      name="lawc-issued-date"
                      class="input-text input-font"
                      placeholder="예) 20110809"
                      title="법정대리인 운전면허 발급일자 여덟자리 입력"
                    />
                  </div>
                </div>
                <div
                  v-if="lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'MERIT'"
                  class="field-control-sub"
                >
                  <div class="field-control-sub">
                    <label
                      for="customer-checkway-merit-no"
                      class="input-sub-text"
                      >보훈번호
                    </label>
                    <input
                      id="customer-checkway-merit-no"
                      v-model="lawcAgntEntrRsvTruthInfo.monmCsntNo"
                      type="text"
                      maxlength="10"
                      @input="onlyNumber"
                      name="lawc-monm-csnt-no"
                      ref="ref_lawcMonmCsntNo"
                      class="input-text input-font"
                      placeholder="'-'없이 입력하세요"
                      title="법정대리인 보훈번호 열 자리 숫자 입력"
                    />
                    <label
                      for="customer-checkway-merit-date"
                      class="input-sub-text"
                      >발급일자</label
                    >
                    <input
                      id="customer-checkway-merit-date"
                      v-model="lawcAgntEntrRsvTruthInfo.isuDt"
                      type="text"
                      @input="onlyNumber"
                      maxlength="8"
                      ref="ref_lawcMeritIsuDt"
                      name="lawc-issued-date"
                      class="input-text input-font"
                      placeholder="예) 20110809"
                      title="법정대리인 보훈번호 발급일자 여덟자리 입력"
                    />
                  </div>
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="guardian-tel-number">연락가능 전화번호</label>
              </dt>
              <dd class="field-control">
                <input
                  id="guardian-tel-number"
                  v-model="registration.lawcAgntTlno"
                  ref="ref_lawcAgntTlno"
                  type="text"
                  name="guardian-tel-number"
                  @input="onlyNumber"
                  maxlength="11"
                  autocomplete="off"
                  class="input-text input-font"
                  placeholder="'-' 없이 숫자만 입력"
                  title="법정대리인의 연락처 입력"
                />
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                주소
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div
                    id="checkbox-container-sameWithCustomerAddress"
                    class="input-container"
                  >
                    <input
                      id="same-address-with-customer"
                      v-model="sameWithCustomerAddress"
                      type="checkbox"
                      name="sameWithCustomerAddress"
                      class="input-checkbox input-text"
                      title="가입자 주소와 동일함 체크"
                    />
                    <label for="same-address-with-customer" class="input-label" @click="copyCustomerAddress"
                      >가입자와 동일</label
                    >
                  </div>
                </div>
                <div class="field-control-sub m-input-half">
                  <input
                    v-model="registration.lawcAgntZpcd"
                    type="text"
                    name="postCode"
                    class="input-text input-width-xsmall input-font input-text-disabled"
                    placeholder="우편번호"
                    readonly
                    title="우편번호"
                  />
                  <span class="field-group-space"></span>
                  <button
                    @click="zipcodeAddressPop('guardian')"
                    ref="ref_zipcodeAddressPop"
                    title="새창열림"
                    type="button"
                  >
                    주소찾기
                  </button>
                </div>
                <div class="field-control-sub">
                  <input
                    v-model="registration.lawcAgntAddr"
                    type="text"
                    name="address1"
                    class="input-text input-width-xlarge input-font input-text-disabled"
                    readonly
                  />
                </div>
                <div class="field-control-sub">
                  <input
                    v-model="registration.lawcAgntDadr"
                    type="text"
                    name="address2"
                    class="input-text input-width-xlarge input-font input-text-disabled"
                    readonly
                  />
                </div>
                <ul class="notice-text-list">
                  <li class="notice-text">
                    청소년 가입신청을 위해서는 법정대리인 명의의 공인인증서가
                    반드시 필요하고 신분확인을 위한 주민등록등본을 Fax 또는
                    파일첨부를 활용하여 대리점에 제출하셔야 합니다.
                  </li>
                </ul>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                법정대리인 동의
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div id="checkbox-container-agree" class="input-container">
                    <input
                      id="guardian-agreement-check"
                      ref="ref_lawcAgntAgrYn"
                      v-model="registration.lawcAgntAgrYn"
                      type="checkbox"
                      name="agree"
                      true-value="Y"
                      false-value="N"
                      class="input-checkbox input-text"
                      title="법정대리인의 동의여부 체크"
                    />
                    <label for="guardian-agreement-check" class="input-label"
                      ><em class="primary-text">(필수)</em> 동의</label
                    >
                  </div>
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      미성년자가 이동전화서비스(데이터서비스 포함)이용,
                      휴대폰(할부)매매, 휴대폰 보험 가입계약 등을 체결하는데
                      있어 본 신청서, 이용약관, 의무약정 등의 제반 사항을
                      확인하고 이에 동의합니다.
                    </li>
                    <li class="notice-text">
                      서비스 가입 및 이용 중 발생하는 요금, 할부금 등 채무에
                      대하여 연대보증책임을 지도록 하겠습니다.
                    </li>
                    <li class="notice-text">
                      만 14세 미만의 경우 개인정보활용 동의서의 제반사항을
                      확인하고 이에 동의합니다.
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isPart1Popup">
      <ZipcodeDirectPopup @close="popupClose" />
    </div>
    <v-dialog />
  </div>
</template>

<script>
import ZipcodeDirectPopup from '../popup/ZipcodeDirectPopup'
import { getComCodeList } from '@/api/metaService'
import { getBlEmailBlock } from '@/api/common'
import { verify } from '@/api/ucube'
import { common } from '~/js/common'

export default {
  name: 'Part1',

  // TODO : 리펙토링 Test
  // props: {
  //   entrRsvTruthInfoProps: Object
  // },
  props: {
    openMarketInfoProps: Object,
    registrationProps: Object,
    entrRsvTruthInfoProps: Object,
    lawcAgntEntrRsvTruthInfoProps: Object
  },

  data() {
    return {
      openMarketInfo: {},
      registration: {},
      entrRsvTruthInfo: {},
      lawcAgntEntrRsvTruthInfo: {},
      isPart1Popup: false,
      sameWithCustomerAddress: false,
      isVerifyGuardianSsn: false,
      chkEmailAgree: false,
      lawcAgntSsn1: '',
      lawcAgntSsn2: '',
      emailDomainList: [],
      validationMethodList: [],
      originValidationMethodList: [],
      driverRegionList: [],
      selectedEmailDomain: '',
      custKdNm: '',
    }
  },

  components: {
    ZipcodeDirectPopup
  },

  created() {
    this.sameWithCustomerAddress = false
  },

  mounted() {
    this.commCodeList()
    this.custKdNm = this.custFormatKdNm()
    this.openMarketInfo = this.openMarketInfoProps
    this.registration = this.registrationProps
    this.entrRsvTruthInfo = this.entrRsvTruthInfoProps
    this.lawcAgntEntrRsvTruthInfo = this.lawcAgntEntrRsvTruthInfoProps

    this.selectedEmailDomain = ""
    for(let i=0; i<this.emailDomainList.length; i++) {
      if(this.$store.state.step1.customer.emailDomain === this.emailDomainList[0].cmmCdv) {
        this.selectedEmailDomain = this.$store.state.step1.customer.emailDomain
        break
      }
    }

    this.sameWithCustomerAddress = false
    this.chkEmailAgree = false
  },

  computed: {
  },

  methods: {
    custFormatKdNm() {
      if (
        this.$store.state.step1.customer.custKdCd === 'A' ||
        this.$store.state.step1.customer.custKdCd === 'B'
      ) {
        return '개인'
      }
      if (this.$store.state.step1.customer.custKdCd === 'C') {
        return '법인'
      }
      if (this.$store.state.step1.customer.custKdCd === 'D') {
        return '외국인'
      }
      return ''
    },
    /** 
     * Function    : onlyNumber
     * Description : input값 숫자 체크
     **/
    onlyNumber(e) {
      if(e.target.name === 'available-phone-number') this.registration.aplcTlno = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'issued-date') this.entrRsvTruthInfo.isuDt = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'license-number') this.entrRsvTruthInfo.drvLcnsNo = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'monm-csnt-no') this.entrRsvTruthInfo.monmCsntNo = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'ssn1') this.$store.state.step1.customer.ssn1 = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'ssn2') this.$store.state.step1.customer.ssn2 = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'lawcSsn1') this.lawcAgntSsn1 = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'lawcSsn2') this.lawcAgntSsn2 = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'lawc-issued-date') this.lawcAgntEntrRsvTruthInfo.isuDt = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'lawc-license-number') this.lawcAgntEntrRsvTruthInfo.drvLcnsNo = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'lawc-monm-csnt-no') this.lawcAgntEntrRsvTruthInfo.monmCsntNo = e.target.value.replace(/[^0-9]/gi, '')
      if(e.target.name === 'guardian-tel-number') this.registration.lawcAgntTlno = e.target.value.replace(/[^0-9]/gi, '')
    },

    /** 
     * Function    : onlyText
     * Description : input값 텍스트 체크
     **/
    onlyText(e) {
      if(e.target.name === 'emailId') this.$store.state.step1.customer.emailId = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      if(e.target.name === 'emailDomain') {
        if(this.selectedEmailDomain !== "") {
          this.selectedEmailDomain = ""
        }
        this.$store.state.step1.customer.emailDomain = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      }
      if(e.target.name === 'lawcAgntNm') this.registration.lawcAgntNm = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
    },

    /** 
     * Function    : commCodeList
     * Description : 공통코드 조회
     **/
    commCodeList() {
      Promise.all([
        getComCodeList('G162'),
        getComCodeList('G116'),
        getComCodeList('DRV_LCNS_ISUE_AREA_CD')
      ]).then(responses => {
        this.emailDomainList = responses[0].data
        this.originValidationMethodList = responses[1].data //진위여부
        this.driverRegionList = responses[2].data //운전면허지역코드

        for(let i=0; i<this.originValidationMethodList.length; i++) {
          if(this.$store.state.step1.customer.custKdCd === 'D') {
            if(this.originValidationMethodList[i].cmmCdv === 'FORGN') {
              this.validationMethodList.push(this.originValidationMethodList[i])
            }
          } else {
            if(this.originValidationMethodList[i].cmmCdv !== 'FORGN') {
              this.validationMethodList.push(this.originValidationMethodList[i])
            }
          }
        }
      })
    },

    /** 
     * Function    : zipcodeAddressPop
     * Description : 우편번호 조회 팝업 호출
     **/
    zipcodeAddressPop(type) {
      this.isPart1Popup = true
      this.$nextTick(() => {
        if (type === 'customer') {
          this.$store.state.zipType = 'customer'
          this.$modal.show('zipcodeAddress')
          return
        }

        if (type === 'guardian') {
          this.$store.state.zipType = 'guardian'
          this.$modal.show('zipcodeAddress')
          return
        }
      })
    },

    /** 
     * Function    : subitEmail
     * Description : 이메일 인증
     **/
    subitEmail() {
      let title = '온라인 가입신청 안내'
      if (!this.$store.state.step1.customer.emailId) {
        this.openAlert(
          title,
          '이메일 아이디를 입력해주세요.',
          this.$refs.ref_emailId
        )
        return
      }
      if (!this.$store.state.step1.customer.emailDomain) {
        this.openAlert(
          title,
          '이메일 도메인을 입력해주세요.',
          this.$refs.ref_emailDomain
        )
        return
      }
      
      let message = ''
      let billEmailAddr =
        this.$store.state.step1.customer.emailId +
        '@' +
        this.$store.state.step1.customer.emailDomain

      if (billEmailAddr.length > 50) {
        this.openAlert(
          title,
          '허용된 이메일 자릿수를 초과하였습니다.\n다른 이메일로 입력바랍니다.',
          this.$refs.ref_emailId
        )
        return
      }
      getBlEmailBlock(billEmailAddr).then(res => {
        let blackRegYn = res.data.dsRes.blackRegYn
        let blockCntYn = res.data.dsRes.blockCntYn
        let blockCntYnMsg = res.data.dsRes.blockCntYnMsg
        if (blackRegYn === 'Y') {
          message =
            '등록하신 이메일 주소는 등록이 제한된 이메일 주소 입니다.\n이메일 주소를 확인하시어 다른 이메일 주소로 등록 해주십시오.\n(이메일 주소 이용자가 발송 차단 요청, 타인 이메일 청구서 다량 수신 건으로 등록 차단 요청)'
          this.chkEmailAgree = false
        } else if (blockCntYn === 'Y') {
          message =blockCntYnMsg
           // '등록하신 이메일 주소는 등록제한 횟수(15건)를 초과한 \n이메일 주소입니다.\n해당 이메일 주소로는 등록이 불가하오니, 다른 이메일 주소를 확인하시어 등록해 주십시오.'
          this.chkEmailAgree = false
        } else {
          message = '이메일 확인 성공하였습니다!'
          this.registration.aplcEmalAddr = billEmailAddr
          this.chkEmailAgree = true
        }
        this.openAlert(title, message)
      })
    },

    /** 
     * Function    : customerSectionValidCondition
     * Description : 가입자 필수값 Validation
     **/
    customerSectionValidCondition() {
      let regExp
      let title = '온라인 가입신청 안내'
      if (!this.registration.aplcTlno) {
        this.openAlert(
          title,
          '연락가능한 전화번호를 입력하세요.',
          this.$refs.ref_aplcTlno
        )
        return false
      }
      regExp = /^[0-9]{10,11}$/
      if (!regExp.test(this.registration.aplcTlno)) {
        this.openAlert(
          title,
          '연락가능한 전화번호는 10자리 이상 숫자를 입력해주세요.',
          this.$refs.ref_aplcTlno
        )
        return false
      }
      if (this.$store.state.step1.customer.custKdCd !== 'A') {
        if (!this.entrRsvTruthInfo.onetIdcdDivsCd) {
          this.openAlert(
            title,
            '신분증 진위확인정보를 선택하세요.',
            this.$refs.ref_onetIdcdDivsCd
          )
          return false
        } else {
          if (
            this.entrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE' &&
            !this.entrRsvTruthInfo.drvLcnsNo
          ) {
            this.openAlert(
              title,
              '운전면허번호를 선택하세요.',
              this.$refs.ref_drvLcnsNo
            )
            return false
          }
          regExp = /^[0-9]{10}$/
          if (
            this.entrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE' &&
            !regExp.test(this.entrRsvTruthInfo.drvLcnsNo)
          ) {
            this.openAlert(
              title,
              '운전면허번호는 10자리 숫자를 입력해주세요.',
              this.$refs.ref_drvLcnsNo
            )
            return false
          }
          if (
            this.entrRsvTruthInfo.onetIdcdDivsCd === 'MERIT' &&
            !this.entrRsvTruthInfo.monmCsntNo
          ) {
            this.openAlert(
              title,
              '보훈번호를 선택하세요.',
              this.$refs.ref_monmCsntNo
            )
            return false
          }
          if (
            this.entrRsvTruthInfo.onetIdcdDivsCd === 'REGID' ||
            this.entrRsvTruthInfo.onetIdcdDivsCd === 'HANDI' ||
            this.entrRsvTruthInfo.onetIdcdDivsCd === 'FORGN'
          ) {
            if (!this.entrRsvTruthInfo.isuDt) {
              this.openAlert(
                title,
                '발급일자를 입력하세요.',
                this.$refs.ref_regisHandiIsuDt
              )
              return false
            }
            regExp = /^[0-9]{8}$/
            if (!regExp.test(this.entrRsvTruthInfo.isuDt)) {
              this.openAlert(
                title,
                '진위여부 발급일자는 8자리 숫자를 입력해주세요.',
                this.$refs.ref_regisHandiIsuDt
              )
              return false
            }
            if (!common.isDate(this.entrRsvTruthInfo.isuDt)) {
              this.openAlert(
                title,
                '진위여부 발급일자를 정확히 입력하세요.',
                this.$refs.ref_regisHandiIsuDt
              )
              return false
            }
          }

          if (this.entrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE') {
            if (!this.entrRsvTruthInfo.isuDt) {
              this.openAlert(
                title,
                '발급일자를 입력하세요.',
                this.$refs.ref_driveIsuDt
              )
              return false
            }
            regExp = /^[0-9]{8}$/
            if (!regExp.test(this.entrRsvTruthInfo.isuDt)) {
              this.openAlert(
                title,
                '진위여부 발급일자는 8자리 숫자를 입력해주세요.',
                this.$refs.ref_driveIsuDt
              )
              return false
            }
            if (!common.isDate(this.entrRsvTruthInfo.isuDt)) {
              this.openAlert(
                title,
                '진위여부 발급일자를 정확히 입력하세요.',
                this.$refs.ref_driveIsuDt
              )
              return false
            }
          }

          if (this.entrRsvTruthInfo.onetIdcdDivsCd === 'MERIT') {
            if (!this.entrRsvTruthInfo.isuDt) {
              this.openAlert(
                title,
                '발급일자를 입력하세요.',
                this.$refs.ref_meritIsuDt
              )
              return false
            }
            regExp = /^[0-9]{8}$/
            if (!regExp.test(this.entrRsvTruthInfo.isuDt)) {
              this.openAlert(
                title,
                '진위여부 발급일자는 8자리 숫자를 입력해주세요.',
                this.$refs.ref_meritIsuDt
              )
              return false
            }
            if (!common.isDate(this.entrRsvTruthInfo.isuDt)) {
              this.openAlert(
                title,
                '진위여부 발급일자를 정확히 입력하세요.',
                this.$refs.ref_meritIsuDt
              )
              return false
            }
          }
        }
      }

      if (!this.registration.billDivsCd) {
        this.openAlert(
          title,
          '청구구분코드를 입력하세요.',
          this.$refs.ref_billDivsCd
        )
        return false
      }
      if (
        !this.registration.crplZpcd ||
        !this.registration.crplAddr ||
        !this.registration.crplDadr
      ) {
        this.openAlert(title, '주소를 다시 입력하세요.', this.$refs.search)
        return false
      }
      if (!this.registration.bltxRcepMthdCd) {
        this.openAlert(
          title,
          '청구서 수령방법을 입력하세요.',
          this.$refs.ref_bltxRcepMthdCd
        )
        return false
      }
      if (!this.$store.state.step1.customer.emailId) {
        this.openAlert(
          title,
          '이메일 아이디를 입력해주세요.',
          this.$refs.ref_emailId
        )
        return false
      }
      if (!this.$store.state.step1.customer.emailDomain) {
        this.openAlert(
          title,
          '이메일 도메인을 입력해주세요.',
          this.$refs.ref_emailDomain
        )
        return false
      }
      if (!this.chkEmailAgree) {
        this.openAlert(
          title,
          '이메일 인증을 완료해주세요.',
          this.$refs.ref_subitEmail
        )
        return false
      }
      return true
    },

    /** 
     * Function    : guardianSectionValidCondition
     * Description : 법정대리인 필수값 Validation
     **/
    guardianSectionValidCondition() {
      let title = '온라인 가입신청 안내'
      if (!this.isVerifyGuardianSsn) {
        this.openAlert(title, '법정대리인 실명확인을 완료하세요.')
        return false
      }

      this.verifySSn()
      let regExp

      if (!this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd) {
        this.openAlert(
          title,
          '법정대리인 신분증 진위확인정보를 선택하세요.',
          this.$refs.ref_lawConetIdcdDivsCd
        )
        return false
      } else {
        if (
          this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE' &&
          !this.lawcAgntEntrRsvTruthInfo.drvLcnsNo
        ) {
          this.openAlert(
            title,
            '법정대리인 운전면허번호를 선택하세요.',
            this.$refs.ref_lawcDriveIsuDt
          )
          return false
        }
        regExp = /^[0-9]{10}$/
        if (
          this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE' &&
          !regExp.test(this.lawcAgntEntrRsvTruthInfo.drvLcnsNo)
        ) {
          this.openAlert(
            title,
            '법정대리인 진위여부 운전면허번호는 10자리 숫자를 입력해주세요.',
            this.$refs.ref_lawcDriveIsuDt
          )
          return false
        }
        if (
          this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'MERIT' &&
          !this.lawcAgntEntrRsvTruthInfo.monmCsntNo
        ) {
          this.openAlert(
            title,
            '법정대리인 보훈번호를 선택하세요.',
            this.$refs.ref_lawcMonmCsntNo
          )
          return false
        }
        if (
          this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'REGID' ||
          this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'HANDI' ||
          this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'FORGN'
        ) {
          if (!this.lawcAgntEntrRsvTruthInfo.isuDt) {
            this.openAlert(
              title,
              '법정대리인 발급일자를 입력하세요.',
              this.$refs.ref_lawcRegisHandiIsuDt
            )
            return false
          }
          regExp = /^[0-9]{8}$/
          if (!regExp.test(this.lawcAgntEntrRsvTruthInfo.isuDt)) {
            this.openAlert(
              title,
              '법정대리인 진위여부 발급일자는 8자리 숫자를 입력해주세요.',
              this.$refs.ref_lawcRegisHandiIsuDt
            )
            return false
          }
          if (!common.isDate(this.lawcAgntEntrRsvTruthInfo.isuDt)) {
            this.openAlert(
              title,
              '법정대리인 진위여부 발급일자를 정확히 입력하세요.',
              this.$refs.ref_lawcRegisHandiIsuDt
            )
            return false
          }
        }
        if (this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE') {
          if (!this.lawcAgntEntrRsvTruthInfo.isuDt) {
            this.openAlert(
              title,
              '법정대리인 발급일자를 입력하세요.',
              this.$refs.ref_lawcDrvLcnsNo
            )
            return false
          }
          regExp = /^[0-9]{8}$/
          if (!regExp.test(this.lawcAgntEntrRsvTruthInfo.isuDt)) {
            this.openAlert(
              title,
              '법정대리인 진위여부 발급일자는 8자리 숫자를 입력해주세요.',
              this.$refs.ref_lawcDrvLcnsNo
            )
            return false
          }
          if (!common.isDate(this.lawcAgntEntrRsvTruthInfo.isuDt)) {
            this.openAlert(
              title,
              '법정대리인 진위여부 발급일자를 정확히 입력하세요.',
              this.$refs.ref_lawcDrvLcnsNo
            )
            return false
          }
        }
        if (this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'MERIT') {
          if (!this.lawcAgntEntrRsvTruthInfo.isuDt) {
            this.openAlert(
              title,
              '법정대리인 발급일자를 입력하세요.',
              this.$refs.ref_lawcMeritIsuDt
            )
            return false
          }
          regExp = /^[0-9]{8}$/
          if (!regExp.test(this.lawcAgntEntrRsvTruthInfo.isuDt)) {
            this.openAlert(
              title,
              '법정대리인 진위여부 발급일자는 8자리 숫자를 입력해주세요.',
              this.$refs.ref_lawcMeritIsuDt
            )
            return false
          }
          if (!common.isDate(this.lawcAgntEntrRsvTruthInfo.isuDt)) {
            this.openAlert(
              title,
              '법정대리인 진위여부 발급일자를 정확히 입력하세요.',
              this.$refs.ref_lawcMeritIsuDt
            )
            return false
          }
        }
      }

      if (!this.registration.lawcAgntTlno) {
        this.openAlert(
          title,
          '법정대리인 연락가능한 전화번호를 입력하세요.',
          this.$refs.ref_lawcAgntTlno
        )
      }
      regExp = /^[0-9]{10,11}$/
      if (!regExp.test(this.registration.lawcAgntTlno)) {
        this.openAlert(
          title,
          '법정대리인 연락가능한 전화번호는 10자리 이상 숫자를 입력해주세요.',
          this.$refs.ref_lawcAgntTlno
        )
        return false
      }

      if (
        !this.registration.lawcAgntZpcd ||
        !this.registration.lawcAgntAddr ||
        !this.registration.lawcAgntDadr
      ) {
        this.openAlert(
          title,
          '법정대리인 주소를 다시 입력하세요.',
          this.$refs.ref_zipcodeAddressPop
        )
        return false
      }
      if (this.registration.lawcAgntAgrYn !== 'Y') {
        this.openAlert(
          title,
          '법정대리인 동의를 체크해주세요.',
          this.$refs.ref_lawcAgntAgrYn
        )
        return false
      }
      return true
    },

    /** 
     * Function    : verifySSn
     * Description : 법정대리인 주민번호 validation
     **/
    verifySSn() {
      let title = '온라인 가입신청 안내'
      let message = ''
      if (this.registration.lawcAgntNm === '') {
        message = '법정대리인 이름을 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_lawcAgntNm)
        return false
      }
      let regExpNm = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|A-Z|0-9|\s]+$/
      if (!regExpNm.test(this.registration.lawcAgntNm)) {
        message = '법정대리인 이름은 한글, 영어, 숫자만 입력 가능합니다.'
        this.openAlert(title, message, this.$refs.ref_lawcAgntNm)
        return false
      }
      if (this.lawcAgntSsn1 === '') {
        message = '법정대리인 주민번호 앞자리를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_lawcAgntSsn1)
        return false
      }
      let regExpSsn1 = /^[0-9]{6}$/
      if (!regExpSsn1.test(this.lawcAgntSsn1)) {
        message = '법정대리인 주민번호 앞자리는 6자리 숫자를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_lawcAgntSsn1)
        return false
      }
      if (this.lawcAgntSsn2 === '') {
        message = '법정대리인 주민번호 뒷자리를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_lawcAgntSsn2)
        return false
      }
      let regExpSsn2 = /^[0-9]{7}$/
      if (!regExpSsn2.test(this.lawcAgntSsn2)) {
        message = '법정대리인 주민번호 뒷자리는 7자리 숫자를 입력해주세요.'
        this.openAlert(title, message, this.$refs.ref_lawcAgntSsn2)
        return false
      }

      return true
    },

    /** 
     * Function    : validCondition
     * Description : Part1 필수값 Validation
     **/
    validCondition() {
      if (!this.customerSectionValidCondition()) return false
      if (this.$store.state.step1.customer.custKdCd === 'A') {
        if (!this.guardianSectionValidCondition()) return false
      }
      return true
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message, ref) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              this.$modal.hide('dialog')
              if (ref) {
                ref.focus()
              }
            }
          }
        ]
      })
    },

    /** 
     * Function    : openAlert
     * Description : 법정대리인 실명인증
     **/
    checkGuardian() {
      if (this.verifySSn()) {
        let title = '온라인 가입신청 안내'
        let info = {
          accessType: 'PO',
          custType: 'A',
          dealCd: this.openMarketInfo.dealCd,
          entrRqstFomNo: this.openMarketInfo.formId,
          opmkNo: this.openMarketInfo.openMarketCode,
          applType: this.openMarketInfo.registrationTypeCode
        }

        //this.registration.decLawcAgntCrypRrno =
        //  this.lawcAgntSsn1 + this.lawcAgntSsn2
        verify(
          this.registration.lawcAgntNm,
          this.lawcAgntSsn1,
          this.lawcAgntSsn2,
          info
        ).then(res => {
          this.openAlert(title, res.data.dsRes.msg)
          this.isVerifyGuardianSsn = true
          this.registration.lawcAgntCrypRrno = res.data.resultData.aplcErrno
        })
      }
    },

    /** 
     * Function    : popupClose
     * Description : 우편번호 팝업 닫힐 시 이벤트
     **/
    popupClose(result) {
      if (result.id === 'ok') {
        if (result.type === 'customer') {
          this.registration.crplZpcd = result.ok.zip
          this.registration.crplAddr = result.ok.roadAddr1
          this.registration.crplDadr = result.ok.addrDetail
          this.$refs.search.focus()
        }
        if (result.type === 'guardian') {
          this.sameWithCustomerAddress = false
          this.registration.lawcAgntZpcd = result.ok.zip
          this.registration.lawcAgntAddr = result.ok.roadAddr1
          this.registration.lawcAgntDadr = result.ok.addrDetail
          this.$refs.ref_zipcodeAddressPop.focus()
        }
      }
      this.isPart1Popup = false
    },

    /** 
     * Function    : savePart1
     * Description : 입력된 값들 index로 보내기 위한 함수
     **/
    savePart1() {
      let part1Data = {
        registration: this.registration,
        entrRsvTruthInfo: this.entrRsvTruthInfo,
        lawcAgntEntrRsvTruthInfo: this.lawcAgntEntrRsvTruthInfo
      }
      return part1Data
    },

    /** 
     * Function    : copyCustomerAddress
     * Description : 법정대리인 주소를 가입자 주소와 동일하게 해주는 함수
     **/
    copyCustomerAddress() {
      if (!this.sameWithCustomerAddress) {
        this.registration.lawcAgntZpcd = this.registration.crplZpcd
        this.registration.lawcAgntAddr = this.registration.crplAddr
        this.registration.lawcAgntDadr = this.registration.crplDadr
      } else {
        this.registration.lawcAgntZpcd = ''
        this.registration.lawcAgntAddr = ''
        this.registration.lawcAgntDadr = ''
      }
    },

    /** 
     * Function    : chgEmailDomain
     * Description : 이메일 주소 셀렉트박스 변경 이벤트
     **/
    chgEmailDomain() {
      if (this.selectedEmailDomain !== "") {
        this.$store.state.step1.customer.emailDomain = this.selectedEmailDomain
      } else {
        this.$store.state.step1.customer.emailDomain = ""
      }
    },
  }
}
</script>

<style scoped>
.notice-indent {
  padding-left: 15px;
  padding-right: 0px;
}
</style>
